// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2BX6Z","text":"styles_text__2BcI1","link":"styles_link__l8cTi","coverageLink":"styles_coverageLink__lx6fg"};